import "./GrayMediaCard.css";
import { useNavigate } from "react-router-dom";

export default function GrayMediaCard({ iconClassName, iconStyle, title, text, image, imageWidth = 100, to, onClick }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) onClick(e);
    if (to) navigate(to);
  };

  return (
    <div
      className="gray-media-card"
      role="button"
      tabIndex={0}
      onClick={handleClick}
    >
      <div className="gray-media-card__image-container">
        {image ? (
          <img
            src={image}
            alt={title || "media"}
            width={imageWidth}
            className="gray-media-card__image"
          />
        ) : (
          iconClassName && <i className={iconClassName} style={iconStyle} />
        )}
      </div>
      <div className="gray-media-card__content">
        {title && <h3 className="gray-media-card__title">{title}</h3>}
        {text && <p className="gray-media-card__description">{text}</p>}
      </div>
    </div>
  );
}